import { TypeaheadSearchBar } from 'venn-components';
import React, { useCallback } from 'react';

import { userActivity } from 'venn-utils';
import { useRecentLibrarySearches } from '../../../../home-page/src/components/logic/useRecentLibrarySearches';

const RECENT_SEARCH_MAX_ITEMS = 5;
interface PortfoliosTypeaheadSearchBarProps {
  searchText: string;
  onSearchTextChange: (arg0: string) => void;
  placeholder: string;
}
export const PortfoliosTypeaheadSearchBar = ({
  searchText = '',
  placeholder,
  onSearchTextChange,
}: PortfoliosTypeaheadSearchBarProps) => {
  const { recentSearches, saveRecentSearch } = useRecentLibrarySearches(
    RECENT_SEARCH_MAX_ITEMS,
    userActivity.USER_PORTFOLIOS_RECENT_QUERIES,
  );
  const handleSearchSelect = useCallback(
    (val: string) => {
      onSearchTextChange(val);
      saveRecentSearch(val);
    },
    [onSearchTextChange, saveRecentSearch],
  );
  const onBlur = useCallback(() => saveRecentSearch(searchText), [saveRecentSearch, searchText]);

  return (
    <TypeaheadSearchBar
      className="w-full"
      placeholder={placeholder}
      value={searchText}
      onChange={onSearchTextChange}
      onSelect={handleSearchSelect}
      onBlur={onBlur}
      debounce={500}
      dropdownOptions={recentSearches}
      dropdownOptionsHeader="Recent Searches"
      disableAutofocus
    />
  );
};
